/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlDateFilterDto
 */
export interface ControlDateFilterDto {
    /**
     * 
     * @type {string}
     * @memberof ControlDateFilterDto
     */
    gt?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDateFilterDto
     */
    gte?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDateFilterDto
     */
    lt?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDateFilterDto
     */
    lte?: string;
}

/**
 * Check if a given object implements the ControlDateFilterDto interface.
 */
export function instanceOfControlDateFilterDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlDateFilterDtoFromJSON(json: any): ControlDateFilterDto {
    return ControlDateFilterDtoFromJSONTyped(json, false);
}

export function ControlDateFilterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDateFilterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'gt': !exists(json, 'gt') ? undefined : json['gt'],
        'gte': !exists(json, 'gte') ? undefined : json['gte'],
        'lt': !exists(json, 'lt') ? undefined : json['lt'],
        'lte': !exists(json, 'lte') ? undefined : json['lte'],
    };
}

export function ControlDateFilterDtoToJSON(value?: ControlDateFilterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'gt': value.gt,
        'gte': value.gte,
        'lt': value.lt,
        'lte': value.lte,
    };
}

